import {
  ALLOWED_ENV,
  SAMPLING_RATES,
  SENTRY_DSN,
  SENTRY_LS_KEY,
  SENTRY_MODULES,
  getWhitelabellingConfig,
  logDebuggingInfo,
} from './common'
import {
  browserProfilingIntegration,
  browserTracingIntegration,
  init,
  moduleMetadataIntegration,
  replayIntegration,
  setTags,
  setTag,
  vueIntegration,
  consoleLoggingIntegration,
} from '@sentry/vue'

import { filterErrorEvents } from './filters'
import { routeErrorsToFederatedDSN } from './transporter'
import { RouteLocationNormalizedGeneric } from 'vue-router'
import { getPageVersion } from '@/util/getPageVersion'

export const initializeSentry = (app: any, router: any, config: any, debug?: boolean) => {
  if (debug) {
    localStorage.setItem(SENTRY_LS_KEY, 'true')
  }

  try {
    if (ALLOWED_ENV.includes(config.mode)) {
      init({
        dsn: SENTRY_DSN,
        environment: config.mode,
        _experiments: { enableMetrics: true },
        integrations: [
          vueIntegration({ app: app, tracingOptions: { trackComponents: false } }),
          browserTracingIntegration({
            router,
            enableInp: true,
            shouldCreateSpanForRequest: url => {
              return url.includes('leadconnectorhq.com') || url.includes('msgsndr.com')
            },
          }),
          browserProfilingIntegration(),
          moduleMetadataIntegration(),
          replayIntegration({
            maskAllText: true,
            blockAllMedia: true,
          }),
          // consoleLoggingIntegration({ levels: ["log","error"] }),
        ],
        beforeSend: filterErrorEvents,
        transport: routeErrorsToFederatedDSN,
        sampleRate: SAMPLING_RATES[config.mode].sampleRate, // error samples
        tracesSampleRate: SAMPLING_RATES[config.mode].tracesSampleRate, // picked randomly, starting with bare minimum
        profilesSampleRate: SAMPLING_RATES[config.mode].profilesSampleRate,
        replaysSessionSampleRate: SAMPLING_RATES[config.mode].replaysSessionSampleRate,
        replaysOnErrorSampleRate: SAMPLING_RATES[config.mode].replaysOnErrorSampleRate,
        attachProps: true,
        enableLogs: false,
        ...getWhitelabellingConfig(config.mode),
      })

      setTags({
        module: SENTRY_MODULES.SPM_TS,
      })

      logDebuggingInfo(`Error Tracking enabled in ${config.mode} mode`)
    } else {
      logDebuggingInfo(`Error Tracking disabled in ${config.mode} mode`)
    }
  } catch (e) {
    logDebuggingInfo('Error Tracking initialized failed')
  }
}

export const configureSentryPageVersion = (to: RouteLocationNormalizedGeneric): void => {
  try {
    const { params: { location_id: locationId } = {}, name: routeName } = to || {}
    const pageVersion = getPageVersion(locationId, routeName)
    setTag('page_version', pageVersion)
  } catch (e) {
    setTag('page_version', undefined)
  }
}
